'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card2Data from '@/textContent/solutions/distribution/card2Data.json';
import card3Data from '@/textContent/solutions/distribution/card3Data.json';
import cardData from '@/textContent/solutions/distribution/cardData.json';
import { motion } from 'framer-motion';
/* ---------------- Animation Variant ---------------- */
const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: 'easeOut' },
    },
};

const page = () => {
    const heroTextContent = {
        heading: "The Distribution Powerhouse You've Been Waiting For",
        caption:
            'Simplify your supply chain. ERPNext streamlines processes and eliminates bottlenecks, so your operations flow smoothly.',
        image: '/images/hero/stock.png',
        buttonText: 'Talk to Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero animation */}
            <motion.div initial="hidden" animate="visible" variants={fadeUp}>
                <Hero {...heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <VideoTextCard data={cardData} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <VideoTextCard data={card2Data} />
            </motion.div>

            {/* Card 3 */}
            <motion.div
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw]"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <VideoTextCard data={card3Data} />
            </motion.div>
        </Fragment>
    );
};

export default page;
